import { render } from "./ExcerciseModal.vue?vue&type=template&id=ced54fe8&scoped=true"
import script from "./ExcerciseModal.vue?vue&type=script&lang=js"
export * from "./ExcerciseModal.vue?vue&type=script&lang=js"

import "./ExcerciseModal.vue?vue&type=style&index=0&id=ced54fe8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ced54fe8"]])

export default __exports__